import { AttendanceStatus, AttendanceStatusNameFragment } from "../../../Utilities";
import * as Fields from "./fields";

export { Fields };

/**
 * Formats the full name of the given instance.
 */
export function name(instance: Omit<AttendanceStatusNameFragment, "__typename">) {
	return Fields.name(instance.name);
}

export function status(
	instance: Pick<
		AttendanceStatus,
		"indicatesAbsent" | "indicatesLateArrival" | "indicatesEarlyDeparture" | "indicatesExcused"
	>,
) {
	let baseStatus = "Present";
	if (instance.indicatesAbsent) {
		baseStatus = "Absent";
	} else if (instance.indicatesLateArrival) {
		baseStatus = "Arrived Late";
	} else if (instance.indicatesEarlyDeparture) {
		baseStatus = "Left Early";
	}

	if (instance.indicatesExcused) {
		baseStatus = `${baseStatus} (Excused)`;
	}
	return baseStatus;
}
